module.exports = __webpack_public_path__ + "static/media/surprise.df477848.png";